// ~/plugins/retailCRM.client.js

// let retailCRMInitPromise = null;
// let retailCRMReady = false; // Флаг готовности
let pendingEvents = []; // Очередь событий

export const createRetailCRM = (retailID, userName) => {
    // валидация и приведение данных к нужному виду
    const RCCprendigEvents = localStorage.getItem("RCC__pending_events");
    if (RCCprendigEvents) {
        // validate data
        let pendigArr = JSON.parse(RCCprendigEvents);
        pendigArr = pendigArr.filter((el) => {
            if (typeof el !== "object" || !el.type) {
                return false;
            }
        });
        pendigArr = pendigArr.map((el) => {
            if (el.data.offer_external_id && typeof el.data.offer_external_id === "number") {
                el.data.offer_external_id = String(el.data.offer_external_id);
            }
            if (el.data?.items?.length) {
                el.data.items = el.data.items.map((i) => {
                    if (i.id) {
                        i.id = Number(i.id);
                    }
                    return i;
                });
            }
            return el;
        });
        localStorage.setItem("RCC__pending_events", JSON.stringify(pendigArr));
    }

    let deviceId = localStorage.getItem("local_retailcrm_id");

    if (!deviceId) {
        deviceId = "customer" + window.crypto.randomUUID();
        localStorage.setItem("local_retailcrm_id", deviceId);
    }

    window._rcco = {
        customer: {
            customer_id: retailID,
            name: userName,
        },
    };

    window._rcct = "dbb2dc50a970b8d1599daf6553abbb67c090005019156b8b5e582e67f1b9e2ed";

    const initRetailCRM = async () => {
        const loader = () => {
            if (typeof window.ocapi !== "undefined") {
                try {
                    window.ocapi.setCustomerSystemId(retailID);

                    console.log("RetailCRM успешно инициализирован с ID:", retailID);

                    // Обрабатываем очередь событий
                    while (pendingEvents.length > 0) {
                        const { eventName, parameters } = pendingEvents.shift();
                        window.ocapi.event(eventName, parameters);
                    }
                    return true;
                } catch (error) {
                    console.error("Ошибка инициализации RetailCRM:", error);
                    return false;
                }
            }
        };

        await new Promise((resolve) => {
            if (loader()) {
                resolve();
                return;
            }

            let attempts = 0;
            const maxAttempts = 10;
            const interval = setInterval(() => {
                attempts++;
                if (loader()) {
                    clearInterval(interval);
                    resolve();
                } else if (attempts >= maxAttempts) {
                    clearInterval(interval);
                    console.warn("Не удалось инициализировать RetailCRM после", maxAttempts, "попыток");
                    // Даже если не удалось, разрешаем Promise, чтобы не висеть
                    resolve();
                }
            }, 500);
        });
    };

    !(function (t) {
        var a = t.getElementsByTagName("head")[0];
        var c = t.createElement("script");
        c.type = "text/javascript";
        c.src = "//c.retailcrm.tech/widget/loader.js";
        c.onload = "initRetailCRM";
        c.addEventListener("load", function () {
            initRetailCRM();
        });
        a.appendChild(c);
    })(document);
};

export default ({ store }) => {
    const isAuthenticated = store.state.auth.loggedIn;
    const retailID = store.state.auth.user?.retail_id || null;
    if (isAuthenticated && retailID) {
        createRetailCRM(retailID, store.state.auth.user?.name || "Безымянный Пользователь");
    }

    // Глобальный метод для отправки событий
    window.$sendRetailCRMEvent = async (eventName, parameters = {}) => {
        if (["cart",'order'].includes(eventName) && !parameters.cart_id) {
            parameters.cart_id = `cart_${retailID}`;
        }

        if (isAuthenticated && retailID) {
            // Если уже готов, отправляем сразу
            try {
                window.ocapi.event(eventName, parameters);
                console.log(`Отправлено событие RetailCRM: ${eventName}`, parameters);
            } catch (error) {
                console.warn(
                    `window.ocapi не доступен после инициализации, событие поставлено в очередь: ${eventName}`
                );
                pendingEvents.push({ eventName, parameters });
            }
        } else {
            console.log("событие не отправлено, пользователь не авторизован или не привязан к retail crm");
        }
    };
};
